import { StoreContext } from '../../../lib/store';
import { TagInjector } from 'common/components/tag-injector';
import * as React from 'react';
import { useContext } from 'react';

export function Component() {
  const store = useContext(StoreContext);

  const {
    injectOnViewable,
    containerSelector,
    useSimpleInjection,
    tag,
    shouldRefreshFrameOnRotation,
    forceResponsiveHtml,
    position: creativePosition,
    marginTop,
    disableUseCustomClose,
    adParser
  } = store.formatConfig;

  const isMraidReady = store.mraidStore.isMraidReady;
  const hasBeenViewable = store.mraidStore.mraidHasBeenViewable;

  return (
    <TagInjector
      isReady={isMraidReady && (!injectOnViewable || hasBeenViewable)}
      useSimpleInjection={useSimpleInjection}
      tag={tag}
      containerSelector={containerSelector}
      shouldRefreshFrameOnRotation={shouldRefreshFrameOnRotation}
      forceResponsiveHtml={forceResponsiveHtml}
      creativePosition={creativePosition}
      marginTop={marginTop}
      onClickIgnored={e => store.userClickHandler.handleCreativeIgnoredClick(e)}
      onIframeResized={store.creativeStore.onCreativeResize.bind(
        store.creativeStore
      )}
      disableUseCustomClose={disableUseCustomClose}
      injectMRAID={store.injectMRAID}
      supportMRAIDExpand={!store.isInAppOpenAuction}
      adParser={adParser}
    />
  );
}
